var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-chat-distributions" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon users-icon" },
              [_c("md-icon", [_vm._v("people")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.chatCountsByUsers")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.chatDistByUsersDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("ChatDistributionsByUser", {
                attrs: {
                  title: _vm.$t("report.chatCountsByUsers"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byUser,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon platform-icon" },
              [_c("md-icon", [_vm._v("devices")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.chatCountByPlatform")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.chatDistByPlatformDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("ChatDistributionsByPlatform", {
                attrs: {
                  title: _vm.$t("report.chatCountByPlatform"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byPlatform,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon answer-icon" },
              [_c("md-icon", [_vm._v("check_circle")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.chatCountsByAns")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.chatDistByAnsDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("ChatDistributionsByAnswer", {
                attrs: {
                  title: _vm.$t("report.chatCountsByAns"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byAnswer,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon handle-icon" },
              [_c("md-icon", [_vm._v("smart_toy")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("report.chatCountsByHandleType"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.chatDistByHandleTypeDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("ChatDistributionsByHandleType", {
                attrs: {
                  title: _vm.$t("report.chatCountsByHandleType"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byHandleType,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }